import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { Modal, MessageBoxFunctionalLayout, Text } from 'wix-style-react';
var DeleteLabelModal = /** @class */ (function (_super) {
    __extends(DeleteLabelModal, _super);
    function DeleteLabelModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeleteLabelModal.prototype.render = function () {
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, dataHook = _a.dataHook, onClose = _a.onClose, onConfirm = _a.onConfirm;
        return (React.createElement(Modal, { "data-hook": dataHook, isOpen: isOpen, onRequestClose: onClose },
            React.createElement(MessageBoxFunctionalLayout, { title: t('labelManagerDeleteModalTitle'), confirmText: t('labelManagerDeleteModalAccept'), cancelText: t('labelManagerDeleteModalCancel'), onOk: onConfirm, onClose: onClose, onCancel: onClose, theme: "red", width: "500px", dataHook: "delete-label-box" },
                React.createElement("div", null,
                    React.createElement(Text, { dataHook: "content" }, t('labelManagerDeleteModalContent'))),
                React.createElement("br", null),
                React.createElement("div", null,
                    React.createElement(Text, { dataHook: "bold-content", weight: "bold" }, t('labelManagerDeleteModalContentBoldWarning'))))));
    };
    return DeleteLabelModal;
}(React.PureComponent));
export default translate()(DeleteLabelModal);
//# sourceMappingURL=DeleteLabelModal.js.map